const extractTabsFromTable = (html: Element) => {
  const tabItemsHtml = html.querySelectorAll('.tabsItem');
  const tabItems: { title: string, subtitle: string, content: string }[] = [];

  tabItemsHtml.forEach((tabItem) => {
    const tableData = tabItem.querySelectorAll('td');
    tabItems.push(
      {
        title: tableData[2].textContent?.trim() || '',
        subtitle: tableData[4].innerHTML || '',
        content: tableData[5].innerHTML || '',
      }
    );
  });

  return tabItems;
};

export default extractTabsFromTable;
